export const UGA_STUDENT_PAGE_PATH = "/uga" as const;

export const UGA_STUDENT_DISCOUNT_CODE = "student2026";

export const UGA_STUDENT_DISCOUNT_PERCENT = 25;

export const UGA_PREMIUM_LIST_PRICE = 1400;

export const UGA_PREMIUM_DISCOUNTED_PRICE = 1050;

export const UGA_STUDENT_DISCOUNT_LABEL =
  "UGA students: 25% off lifetime access";

export const formatUgaPrice = (amount: number): string =>
  amount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
